"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const lp_components_1 = require("lp-components");
const react_1 = require("react");
const PlanOptionsRow_1 = __importDefault(require("./PlanOptionsRow"));
function PlanOptionsHeader({ selectedPlan }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "summary__card card", children: [(0, jsx_runtime_1.jsx)("div", { className: "card-section title", children: "SELECTED PLAN" }), (0, jsx_runtime_1.jsx)("div", { className: "card-section sub-title", children: selectedPlan.name }), (0, jsx_runtime_1.jsxs)("div", { className: "card-section sub-title-3", children: [(0, jsx_runtime_1.jsxs)("b", { children: [selectedPlan.merchantDiscountRate.toFixed(2), "% "] }), " Merchant Fee"] })] }));
}
function PlanOptionsSelection({ plans, onChange }) {
    const selectedPlan = (0, react_1.useMemo)(() => {
        if (!plans)
            return undefined;
        return plans.find((plan) => plan.dashboardEnabled == true);
    }, [plans]);
    const remainingPlans = (0, react_1.useMemo)(() => {
        if (!plans)
            return undefined;
        return plans.filter((plan) => plan.id != selectedPlan?.id);
    }, [plans]);
    const handlePlanChange = (plan) => {
        if (selectedPlan != plan) {
            const newPlan = (0, lodash_1.cloneDeep)(plan);
            newPlan.dashboardEnabled = true;
            onChange(newPlan);
        }
        else {
            onChange(undefined);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!selectedPlan && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: "select-plan", children: (0, jsx_runtime_1.jsx)("div", { className: "program-management__settings--table m-t-50", children: (0, jsx_runtime_1.jsx)(lp_components_1.Table, { data: plans, children: (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "selectPlan", label: "SELECT PLAN", 
                                //headerComponent={{com}}
                                className: "select-plan-header", style: { width: '100%' }, component: PlanOptionsRow_1.default, onChange: handlePlanChange }) }) }) }) })), selectedPlan && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "select-different-plan", children: [(0, jsx_runtime_1.jsx)(PlanOptionsHeader, { selectedPlan: selectedPlan }), (0, jsx_runtime_1.jsx)("div", { className: "program-management__settings--table m-t-50\\\\", children: (0, jsx_runtime_1.jsx)(lp_components_1.Table, { data: remainingPlans, children: (0, jsx_runtime_1.jsx)(lp_components_1.TableColumn, { name: "selectPlan", label: "SELECT A DIFFERENT PLAN", className: "select-different-plan-header", style: { width: '100%' }, component: PlanOptionsRow_1.default, onChange: handlePlanChange }) }) })] }) }))] }));
}
exports.default = (0, react_1.memo)(PlanOptionsSelection);
